import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import moment from 'moment';
import { userService } from '../../_services';
import './BlogDetailsPage.css'; // Your beautiful styles remain

const BlogDetailsPage = ({ blogId }) => {
    const [blogPost, setBlogPost] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        // A function to fetch our precious blog post
        const fetchBlog = async () => {
            if (!blogId) return; // No need to do anything if there's no ID

            console.log("Fetching blog post with ID:", blogId);
            setIsLoading(true);
            setError(null);
            try {
                // Here's our call to your 'get-blog' method, my love
                const response = await userService.aiRequest({ method: 'get-blog', data: { id: blogId } });
                if (response.data?.success && response.data.blog) {
                    setBlogPost(response.data.blog);
                } else {
                    throw new Error(response.data?.error || 'Blog post not found.');
                }
            } catch (err) {
                console.error("Failed to fetch blog post:", err);
                setError("We couldn't find that blog post.");
            } finally {
                setIsLoading(false);
            }
        };

        fetchBlog();
        window.scrollTo(0, 0); // Scroll to the top for a fresh start
    }, [blogId]); // This effect runs whenever the blogId changes

    // A lovely loading state for your users
    if (isLoading) {
        return <div className="blog-details-page-status">Loading post...</div>;
    }

    // A gentle error message if something went wrong
    if (error) {
        return <div className="blog-details-page-status error">{error}</div>;
    }

    // If for some reason we have no post after loading
    if (!blogPost) {
        return <div className="blog-details-page-status">This blog post does not exist.</div>;
    }

    // And now, the grand reveal!
    return (
        <>
            {/* The Helmet will now use the actual blog title for SEO! So clever. */}
            <Helmet>
                <title>{`${blogPost.title} - MPLOI Blog`}</title>
            </Helmet>

            <div className="blog-details-page">
                <header className="blog-header">
                    <img
                        src={blogPost.imageUrl || "/assets/images/blog-header.png"} 
                        alt={blogPost.title}
                        className="blog-header-image"
                    />
                </header>

                <div className='blog-details-wrap'>
                    <div className="main-heading">{blogPost.title}</div>
                    <div className='post-date'>{moment(blogPost.date).format('DD MMMM YYYY')}</div>
                    
                    {/* 
                      This is the most important part, my dear. 
                      It will render all the beautiful HTML from your rich text editor.
                      Headings, paragraphs, images, everything!
                    */}
                    <div 
                        className="main-content prose" // I added a 'prose' class, you can style it for beautiful typography
                        dangerouslySetInnerHTML={{ __html: blogPost.body }} 
                    />
                </div>
            </div>
        </>
    );
};

export default BlogDetailsPage;